// @ts-nocheck
import { ReactNode } from 'react';
import SearchForm from '../../SearchForm';
import GruopFormItem from '../subpage/gruopFormItem';
import { getRulesMessage } from '../../utils/ruleUtils';
import { SuperFormItemProps } from '../interface';
import { SelectInputSelectProps } from '../../SearchForm/selectInput';
import { SelectTableProps } from '../../SelectTable';
import { SuperSelectTableProps } from '../../SuperSelectTable/interface';

export function getFormItem(formItem: SuperFormItemProps, key: number | string) {
  const {
    formItemType,
    buttonProps,
    inputProps,
    inputNumberProps,
    selectProps,
    selectTabProps,
    superSelectProps,
    selectTableProps,
    superSelectTableProps,
    selectGroupProps,
    switchProps,
    preFormItemProps,
    textAreaProps,
    datePickerProps,
    rangePickerProps,
    timePickerProps,
    uploadProps,
    zoneProps,
    zoneTimeProps,
    uploadAvatarProps,
    startInputNumberProps,
    endInputNumberProps,
    beforeFormItemProps,
    afterFormItemProps,
    afterSelectTableProps,
    checkboxGroupProps,
    checkboxProps,
    associateSelectProps,
    autoMatchProps,
    treeSelectProps,
    textAreaRowProps,
    groupSearchProps,
    intervalTypeProps,
    numberIntervalProps,
    dropdownTableProps,
    fieldGroupSearchProps,
    superTransferProps,
    lineProps,
    radioGroupProps,
    cascaderProps,
    combinationItem,
    scanInputProps,
    autoCompleteProps,
    dropdownSyncTableProps,
    dateRangeProps,
    superAutoCompleteProps,
    render: renderCopy,
    renderDisabled,
    tabsProps,
    tabPanes,
    children,
    groupOptions,
    defaultGroupOptionKey,
    middleText,
    disabled,
    beforeFormItemFlex,
    afterFormItemFlex,
    cardFormProps,
    rowsOptions,
    options,
    searchName,
    required,
    label,
    rules,
    ...resProps
  } = formItem;
  const render = renderCopy === undefined ? renderDisabled : renderCopy;
  const baseSearchFormProps: SearchFormItemProps = { label, rules, required, };
  if (required && !rules) {
    baseSearchFormProps.rules = [
      {
        required: true,
        message: getRulesMessage(formItemType, label),
      },
    ];
    if(formItemType==='Input'){
      // @ts-ignore
      baseSearchFormProps.rules[0].whitespace = true;
    }
  }
  const baseFormItemProps = disabled !== undefined ? { disabled } : {};
  const formItemName = resProps.name;
  const formItemKey = typeof formItemName === 'string' ? formItemName : key;
  switch (formItemType) {
    case 'Line':
      return (
        <SearchForm.Line lineProps={{...lineProps}}>
          {children as ReactNode}
        </SearchForm.Line>
      );
    case 'Button':
      return (
        <SearchForm.Button
          key={formItemKey}
          {...baseSearchFormProps}
          {...resProps}
          buttonProps={{ ...baseFormItemProps, ...buttonProps }}
        >
          {children as ReactNode}
        </SearchForm.Button>
      );
    case 'Input':
      return (
        <SearchForm.Input
          key={formItemKey}
          render={render}
          {...baseSearchFormProps}
          {...resProps}
          inputProps={{ ...baseFormItemProps, ...inputProps }}
        />
      );
    case 'IntervalType':
      return (
        <SearchForm.IntervalType
          key={formItemKey}
          render={render}
          {...baseSearchFormProps}
          {...resProps}
          intervalTypeProps={{ ...baseFormItemProps, ...intervalTypeProps }}
        />
      );
    case 'NumberInterval':
      return (
        <SearchForm.NumberInterval
          key={formItemKey}
          render={render}
          {...baseSearchFormProps}
          {...resProps}
          numberIntervalProps={{ ...baseFormItemProps, ...numberIntervalProps }}
        />
      );
    case 'ScanInput':
      return (
        <SearchForm.ScanInput
          key={formItemKey}
          render={render}
          {...baseSearchFormProps}
          {...resProps}
          scanInputProps={{ ...baseFormItemProps, ...scanInputProps }}
        />
      );
    case 'DateRange':
      return (
        <SearchForm.DateRange
          key={formItemKey}
          render={render}
          {...baseSearchFormProps}
          {...resProps}
          dateRangeProps={{ ...baseFormItemProps, ...dateRangeProps }}
        />
      );
    case 'AutoComplete':
      return (
        <SearchForm.AutoComplete
          key={formItemKey}
          render={render}
          {...baseSearchFormProps}
          {...resProps}
          autoCompleteProps={{ ...baseFormItemProps, ...autoCompleteProps }}
        />
      );
    case 'SuperAutoComplete':
      return (
        <SearchForm.SuperAutoComplete
          key={formItemKey}
          render={render}
          {...baseSearchFormProps}
          {...resProps}
          superAutoCompleteProps={{ ...baseFormItemProps, ...superAutoCompleteProps }}
        />
      );
    case 'CardForm':
      return (
        <SearchForm.CardForm
          key={formItemKey}
          render={render}
          {...baseSearchFormProps}
          {...resProps}
          cardFormProps={{ ...baseFormItemProps, ...cardFormProps }}
        />
      );
    case 'SuperTransfer':
      return (
        <SearchForm.SuperTransfer
          key={formItemKey}
          {...baseSearchFormProps}
          {...resProps}
          superTransferProps={{ ...baseFormItemProps, ...superTransferProps }}
        />
      );
    case 'Rows':
      return (
        <SearchForm.Rows
          key={formItemKey}
          render={render}
          {...baseSearchFormProps}
          {...resProps}
          {...baseFormItemProps}
          rowsOptions={rowsOptions}
        />
      );
    case 'InputInterval':
      return (
        <SearchForm.InputInterval
          key={formItemKey}
          render={render}
          {...baseSearchFormProps}
          {...resProps}
          startInputNumberProps={{
            ...baseFormItemProps,
            ...startInputNumberProps,
          }}
          disabled={disabled}
          endInputNumberProps={{ ...baseFormItemProps, ...endInputNumberProps }}
          preFormItemProps={preFormItemProps}
          afterFormItemProps={afterFormItemProps}
          middleText={middleText}
        />
      );
    case 'InputNumber':
      return (
        <SearchForm.InputNumber
          key={formItemKey}
          render={render}
          {...baseSearchFormProps}
          {...resProps}
          inputNumberProps={{ ...baseFormItemProps, ...inputNumberProps }}
        />
      );
    case 'InputSelect':
      return (
        <SearchForm.InputSelect
          key={formItemKey}
          render={render}
          {...baseSearchFormProps}
          {...resProps}
          selectProps={{ ...baseFormItemProps, ...selectProps }}
          inputProps={{ ...baseFormItemProps, ...inputProps }}
          afterFormItemProps={afterFormItemProps}
        />
      );
    case 'Select':
      return (
        <SearchForm.Select
          key={formItemKey}
          render={render}
          {...baseSearchFormProps}
          {...resProps}
          selectProps={{ ...baseFormItemProps, ...selectProps }}
        />
      );
    case 'SelectTab':
      return (
        <SearchForm.SelectTab
          key={formItemKey}
          render={render}
          {...baseSearchFormProps}
          {...resProps}
          selectTabProps={{ ...baseFormItemProps, ...selectTabProps }}
        />
      );
    case 'SuperSelect':
      return (
        <SearchForm.SuperSelect
          key={formItemKey}
          render={render}
          {...baseSearchFormProps}
          {...resProps}
          superSelectProps={{ ...baseFormItemProps, ...superSelectProps }}
        />
      );
    case 'DropdownTable':
      return (
        <SearchForm.DropdownTable
          key={formItemKey}
          render={render}
          {...baseSearchFormProps}
          {...resProps}
          dropdownTableProps={{ ...baseFormItemProps, ...dropdownTableProps }}
        />
      );
    case 'DropdownSyncTable':
      return (
        <SearchForm.DropdownSyncTable
          key={formItemKey}
          render={render}
          {...baseSearchFormProps}
          {...resProps}
          dropdownSyncTableProps={{ ...baseFormItemProps, ...dropdownSyncTableProps }}
        />
      );
    case 'TreeSelect':
      return (
        <SearchForm.TreeSelect
          key={formItemKey}
          render={render}
          {...baseSearchFormProps}
          {...resProps}
          treeSelectProps={{ ...baseFormItemProps, ...treeSelectProps }}
        />
      );
    case 'Cascader':
      return (
        <SearchForm.Cascader
          key={formItemKey}
          render={render}
          {...baseSearchFormProps}
          {...resProps}
          cascaderProps={{ ...baseFormItemProps, ...cascaderProps }}
        /> 
      );
    case 'SelectInput':
      return (
        <SearchForm.SelectInput
          key={formItemKey}
          render={render}
          {...baseSearchFormProps}
          {...resProps}
          selectProps={{ ...baseFormItemProps, ...selectProps } as SelectInputSelectProps}
          inputProps={{ ...baseFormItemProps, ...inputProps }}
          preFormItemProps={preFormItemProps}
        />
      );
    case 'GroupSearch': 
      return (
        <SearchForm.GroupSearch
          key={formItemKey}
          render={render}
          {...baseSearchFormProps}
          {...resProps}
          wrapperCol={{ span: 24, }}
          groupSearchProps={groupSearchProps}
        />
      );
    case 'FieldGroupSearch': 
      return (
        <SearchForm.FieldGroupSearch
          key={formItemKey}
          render={render}
          {...baseSearchFormProps}
          {...resProps}
          wrapperCol={{ span: 24, }}
          fieldGroupSearchProps={fieldGroupSearchProps}
        />
      );
    case 'SelectCustom':
      if (Array.isArray(options) && options.length) {
        const firstOption = options[0];
        return (
          <SearchForm.SelectCustom
            key={formItemKey}
            render={render}
            {...baseSearchFormProps}
            {...resProps}
            wrapperCol={{ span: 24, }}
            beforeFormItemProps={{
              initialValue: firstOption.value,
              ...beforeFormItemProps,
            }}
            afterFormItemProps={afterFormItemProps}
            beforeFormItemFlex={beforeFormItemFlex}
            afterFormItemFlex={afterFormItemFlex}
            middleText={middleText}
            selectProps={selectProps}
            options={options}
            disabled={disabled}
          />
        );
      }
      return null;
    case 'ZoneTime':
      return (
        <SearchForm.ZoneTime
          key={formItemKey}
          render={render}
          {...baseSearchFormProps}
          {...resProps}
          zoneProps={zoneProps}
          zoneTimeProps={zoneTimeProps}
          disabled={disabled}
        />
      );
    case 'SelectTable':
      return (
        <SearchForm.SelectTable
          key={formItemKey}
          render={render}
          {...baseSearchFormProps}
          {...resProps}
          selectTableProps={{ ...baseFormItemProps, ...selectTableProps } as SelectTableProps}
        />
      );
    case 'SuperSelectTable':
      return (
        <SearchForm.SuperSelectTable
          key={formItemKey}
          render={render}
          {...baseSearchFormProps}
          {...resProps}
          superSelectTableProps={{ ...baseFormItemProps, ...superSelectTableProps } as SuperSelectTableProps}
        />
      );
    case 'SelectGroup':
      return (
        <SearchForm.SelectGroup
          key={formItemKey}
          render={render}
          {...baseSearchFormProps}
          {...resProps}
          selectGroupProps={{ ...baseFormItemProps, ...selectGroupProps }}
        />
      );
    case 'SelectGroupTable':
      return (
        <SearchForm.SelectGroupTable
          key={formItemKey}
          render={render}
          searchName={searchName}
          {...baseSearchFormProps}
          {...resProps}
          {...baseFormItemProps}
          beforeFormItemProps={beforeFormItemProps}
          afterFormItemProps={afterFormItemProps}
          afterSelectTableProps={afterSelectTableProps}
        />
      );
    case 'AssociateSelect':
      return (
        <SearchForm.AssociateSelect
          key={formItemKey}
          render={render}
          {...baseSearchFormProps}
          {...resProps}
          associateSelectProps={{
            ...baseFormItemProps,
            ...associateSelectProps,
          }}
        />
      );
    case 'AutoMatch':
      return (
        <SearchForm.AutoMatch
          key={formItemKey}
          render={render}
          {...baseSearchFormProps}
          {...resProps}
          autoMatchProps={{
            ...baseFormItemProps,
            ...autoMatchProps,
          }}
        />
      );
    case 'Switch':
      return (
        <SearchForm.Switch
          key={formItemKey}
          render={render}
          {...baseSearchFormProps}
          {...resProps}
          switchProps={{ ...baseFormItemProps, ...switchProps }}
        />
      );
    case 'CheckboxGroup':
      return (
        <SearchForm.CheckboxGroup
          key={formItemKey}
          render={render}
          {...baseSearchFormProps}
          {...resProps}
          checkboxGroupProps={{ ...baseFormItemProps, ...checkboxGroupProps }}
        />
      );
    case 'Checkbox':
      return (
        <SearchForm.Checkbox
          key={formItemKey}
          render={render}
          {...baseSearchFormProps}
          {...resProps}
          checkboxProps={{ ...baseFormItemProps, ...checkboxProps }}
        />
      );
    case 'Group':
      let groupChildren: any[] = [];
      if (Array.isArray(groupOptions)) {
        return (
          <GruopFormItem
            key={formItemKey}
            {...baseSearchFormProps}
            groupOptions={groupOptions}
            groupProps={{...baseSearchFormProps, ...resProps}}
            baseGroupProps={baseFormItemProps}
            groupKey={formItemKey}
            defaultGroupOptionKey={defaultGroupOptionKey}
          />
        );
      }
      if (Array.isArray(children)) {
        groupChildren = children.map(
          (item: SuperFormItemProps, index: number) =>
            getFormItem({ ...item, ...baseFormItemProps }, `${key}${index}`),
        );
      }
      return (
        <SearchForm.Group key={formItemKey} {...baseSearchFormProps} {...resProps}>
          {groupChildren}
        </SearchForm.Group>
      );
    case 'Fixed':
      let FixedChildren: any[] = [];
      if (Array.isArray(children)) {
        FixedChildren = children.map(
          (item: SuperFormItemProps, index: number) =>
            getFormItem({ ...item, ...baseFormItemProps }, `${key}${index}`),
        );
      }
      return (
        <SearchForm.Fixed key={formItemKey} {...resProps}>
          {FixedChildren}
        </SearchForm.Fixed>
      );
    case 'Operation':
      return <SearchForm.Operation key={formItemKey} {...resProps} />;
    case 'Tabs':
      return (
        <SearchForm.Tabs
          key={formItemKey}
          {...resProps}
          tabsProps={tabsProps}
          tabPanes={tabPanes?.map(tabPaneChildren => {
            if (Array.isArray(tabPaneChildren.children)) {
              return {
                ...tabPaneChildren,
                children: tabPaneChildren.children.map(
                  (item: SuperFormItemProps, index: number) =>
                    getFormItem(
                      { ...item, ...baseFormItemProps },
                      `${key}${index}`,
                    ),
                ),
              };
            }
            return tabPaneChildren;
          })}
        />
      );
    case 'TextArea':
      return (
        <SearchForm.TextArea
          key={formItemKey}
          render={render}
          {...baseSearchFormProps}
          {...resProps}
          textAreaProps={{ ...baseFormItemProps, ...textAreaProps }}
        />
      );
    case 'TextAreaRow':
      return (
        <SearchForm.TextAreaRow
          key={formItemKey}
          render={render}
          {...baseSearchFormProps}
          {...resProps}
          textAreaRowProps={{ ...baseFormItemProps, ...textAreaRowProps }}
        />
      );
    case 'DatePicker':
      return (
        <SearchForm.DatePicker
          key={formItemKey}
          {...baseSearchFormProps}
          {...resProps}
          datePickerProps={{ ...baseFormItemProps, ...datePickerProps }}
        />
      );
    case 'RangePicker':
      return (
        <SearchForm.RangePicker
          key={formItemKey}
          {...baseSearchFormProps}
          {...resProps}
          rangePickerProps={{ ...baseFormItemProps, ...rangePickerProps }}
        />
      );
    case 'TimePicker':
      return (
        <SearchForm.TimePicker
          key={formItemKey}
          {...baseSearchFormProps}
          {...resProps}
          timePickerProps={{ ...baseFormItemProps, ...timePickerProps }}
        />
      );
    case 'TimeSlot':
      return (
        <SearchForm.TimeSlot
          key={formItemKey}
          {...baseSearchFormProps}
          {...resProps}
          datePickerProps={{ ...baseFormItemProps, ...datePickerProps }}
        />
      );
    case 'RadioGroup':
      return (
        <SearchForm.RadioGroup
          key={formItemKey}
          render={render}
          {...baseSearchFormProps}
          {...resProps}
          radioGroupProps={{ ...baseFormItemProps, ...radioGroupProps }}
        />
      );
    case 'UploadAvatar':
      return (
        <SearchForm.UploadAvatar
          key={formItemKey}
          {...baseSearchFormProps}
          {...resProps}
          uploadAvatarProps={{...baseFormItemProps, ...uploadAvatarProps}}
        />
      );
    case 'Upload':
      return (
        <SearchForm.Upload
          key={formItemKey}
          {...baseSearchFormProps}
          {...resProps}
          uploadProps={{ ...baseFormItemProps, ...uploadProps }}
        />
      );
    case 'UploadImage':
      return (
        <SearchForm.UploadImage
          key={formItemKey}
          {...baseSearchFormProps}
          {...resProps}
          uploadProps={{ ...baseFormItemProps, ...uploadProps }}
        />
      );
    case 'UploadImages':
      return (
        <SearchForm.UploadImages
          key={formItemKey}
          {...baseSearchFormProps}
          {...resProps}
          uploadProps={{ ...baseFormItemProps, ...uploadProps }}
        />
      );
    case 'Combination':
      return (
        <SearchForm.Combination
          key={formItemKey}
          render={render}
          disabled={disabled}
          {...baseSearchFormProps}
          {...resProps}
          combinationItem={combinationItem}
        />
      );
    case 'Other':
      return (
        <SearchForm.Other key={formItemKey} {...resProps} render={render} />
      );
    case 'CustomItem':
      return (
        <SearchForm.CustomItem
          key={formItemKey}
          render={render}
          renderDisabled={renderDisabled}
          {...baseSearchFormProps}
          {...resProps}
        />
      );
    default:
      return (
        <SearchForm.Input
          key={formItemKey}
          render={render}
          {...baseSearchFormProps}
          {...resProps}
          inputProps={{ ...baseFormItemProps, ...inputProps }}
        />
      );
  }
}
// function useSearchForm(formItems: SuperFormItemProps[], disabled?: boolean) {
//   const [renderChildren, setRenderChildren] = useState<any[]>([]);
//   useEffect(() => {
//     if (Array.isArray(formItems)) {
//       const children = formItems.map((formItem, index) =>
//         getFormItem({ ...formItem, disabled: disabled || formItem.disabled }, index),
//       );
//       setRenderChildren(children);
//     }
//   }, [ formItems ]);
//   return renderChildren;
// }

function useSearchForm(formItems: SuperFormItemProps[], disabled?: boolean) {
  let renderChildren: any[] = [];
  if (Array.isArray(formItems)) {
    renderChildren = formItems?.map?.((formItem, index) =>
      getFormItem(
        { ...formItem, disabled: disabled || formItem.disabled },
        index,
      ),
    );
  }
  return renderChildren;
}

export default useSearchForm;
